import {
    YourInsightFilterContentSubType,
    YourInsightFilterContentType,
} from "../types/filters/yourInsights";
import { TopNavBarTabs, TabQueryParamValue } from "../types/navigation";

import {
    IHubQueryParam,
    YourInsightsContentTypeParam,
    YourInsightsSubTypeParam,
} from "./permission.utils";
import { getValueFromSearchParams } from "./window.utils";

export const getYourInsightsSubType = ():
    | YourInsightFilterContentSubType
    | undefined => {
    const subType = getValueFromSearchParams(
        IHubQueryParam.YOUR_INSIGHT_SUB_TYPE,
    );
    switch (subType) {
        case YourInsightsSubTypeParam.WORKBENCH:
            return YourInsightFilterContentSubType.WORKBENCH_INSIGHTS;
        case YourInsightsSubTypeParam.PACKAGED:
            return YourInsightFilterContentSubType.PACKAGED_INSIGHTS;
        default:
            return undefined;
    }
};

export const getYourInsightsContentType = (): YourInsightFilterContentType => {
    const contentType = getValueFromSearchParams(
        IHubQueryParam.YOUR_INSIGHT_CONTENT_TYPE,
    );
    if (contentType === YourInsightsContentTypeParam.PITCHED_CONTENT) {
        return YourInsightFilterContentType.PITCHED_CONTENT;
    }
    return YourInsightFilterContentType.INSIGHTS;
};

export const getYourInsightsContentTypeQueryParam = (
    contentType: YourInsightFilterContentType,
): string => {
    return contentType === YourInsightFilterContentType.PITCHED_CONTENT
        ? YourInsightsContentTypeParam.PITCHED_CONTENT
        : YourInsightsContentTypeParam.INSIGHTS;
};

export const getYourInsightsSubTypeQueryParam = (
    subType: YourInsightFilterContentSubType,
): string => {
    return subType === YourInsightFilterContentSubType.WORKBENCH_INSIGHTS
        ? YourInsightsSubTypeParam.WORKBENCH
        : YourInsightsSubTypeParam.PACKAGED;
};

export const initialTab = (): TopNavBarTabs => {
    const tabFromQuery = getValueFromSearchParams(IHubQueryParam.INITIAL_TAB);

    if (tabFromQuery === TabQueryParamValue.GENERATED_INSIGHTS.toString()) {
        return TopNavBarTabs.YOUR_INSIGHT_DECKS;
    }

    return TopNavBarTabs.ALL_INSIGHTS;
};

export const getTabQueryParam = (tab: TopNavBarTabs): TabQueryParamValue => {
    switch (tab) {
        case TopNavBarTabs.YOUR_INSIGHT_DECKS:
            return TabQueryParamValue.GENERATED_INSIGHTS;
        case TopNavBarTabs.ALL_INSIGHTS:
        default:
            return TabQueryParamValue.ALL_INSIGHTS;
    }
};

export const isAllInsightsTab = (tab: TopNavBarTabs): boolean =>
    tab === TopNavBarTabs.ALL_INSIGHTS;
